import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showModal } from '../../actions/modal';
import Table from '../common/Table';
import styled from '@emotion/styled';
import { fetchGetEshopsInfo } from '../../actions/settings';
import { useAutoTranslation } from '../../helpers/useAutoTranslation';

export const eshopTypeToName = {
  //TODO: Дополнить список всеми возможными названиями 123
  WILDBERRIES: `Wildberries`,
  KASPI: `Kaspi`,
  LEROY_MERLIN: 'Леруа Мерлен',
};

const Wrapper = styled.div`
  padding-bottom: 0 !important;

  .badge {
    font-size: 12px;
    font-weight: 600;
  }

  .table-item {
    .title-wrapper {
      width: fit-content;
      position: relative;
    }

    .row-title {
      color: #72747b;
      font-weight: 500;
      font-size: 13px;
      margin: 0;
    }

    .row-comment {
      font-size: 11px;
      margin: 2px 0 0;
      color: #98a6ad;
    }

    i {
      display: none;
    }

    &:hover i {
      position: absolute;
      right: -20px;
      top: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      color: #98a6ad;
      cursor: pointer;
    }
  }
`;

const EshopsBlock = () => {
  const { eShops } = useSelector((state) => state.settings);

  const { t } = useAutoTranslation();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchGetEshopsInfo());
  }, []);

  const rows =
    eShops?.map((item) => ({
      data: [
        {
          value: (
            <div className="title-wrapper">
              <h4 className="row-title">{item.name}</h4>
              {item.isDefault && <p className="row-comment">По умолчанию</p>}
              <i
                className="fe-edit-2"
                onClick={() =>
                  dispatch(showModal(`EditEshopSettings`, { title: t(`Редактирование`), item }))
                }
              />
            </div>
          ),
        },
        { value: eshopTypeToName[item.type] || item.type },
        {
          value: (
            <div className="title-wrapper">
              <h4 className="row-title">{item.percentStock}</h4>
            </div>
          ),
        },
        {
          value: (
            <div className="title-wrapper">
              <h4 className="row-title">{item.lastStock || ''}</h4>
            </div>
          ),
        },
      ],
    })) || [];

  return (
    <>
      <div className="border-bottom">
        <h4 className="header-title">{t('Источники заказов')}</h4>
      </div>
      <Wrapper>
        <Table
          data={{
            cols: [
              t(`Наименование`),
              t(`Тип`),
              t(`Процент остатков`),
              t(`Выгружать последние N шт в данный магазин`),
            ],
            rows,
          }}
        />
      </Wrapper>
    </>
  );
};

export default EshopsBlock;
